import { Box } from '@mui/material'
import { sx } from '@lucan/base-ui'

export default function Contenitore(props) {
  const { children, ...rest } = props

  return (
    <Box
      {...rest}
      {...sx(rest, {
        textAlign: 'left',
        backgroundColor: '#fff',
        width: { sm: '100%', },
        maxWidth: { sm: '100%', md: 960, lg: 1176, xl: 1320 },
        margin: 'auto',
        p: 1
      })}
    >
      {children}
    </Box>
  )
}